import { useEffect } from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";

const Layout = ({ children }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Navbar />
            <main id="main" style={{ paddingTop: '50px' }}>
                {children}
            </main>
            <Footer />
        </>
    );
};

export default Layout